// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DespesasCategorias_DeleteInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/despesas_categorias/delete
 *
 * Deletes an expense category.
 */
import { registerContract } from './validate'

export interface DespesasCategorias_DeleteInput {
despesa_categoria_id: number
}

registerContract('DespesasCategorias_DeleteInput', {
  despesa_categoria_id: { type: 'number',  required: true },
})
